import FTLSelect from "./components/FTLSelect";
export default FTLSelect;
//# sourceMappingURL=index.js.map